import PropTypes from "prop-types";
import React from "react";
import {
  Bar,
  BarText,
  BarValue,
  Bars,
  Container,
  LabelLine,
  LabelLineText,
  Labels
} from "./styled/live-rdc-bar-chart";

function LiveRdcBarChart({ maxValue, values }) {
  const steps = 5;
  const stepAmount = maxValue / steps;

  return (
    <Container>
      <Labels>
        {Array.from({ length: steps }, (_, index) =>
          Math.round((index + 1) * stepAmount)
        )
          .reverse()
          .map((value) => (
            <LabelLine key={value}>
              <LabelLineText>{value}</LabelLineText>
            </LabelLine>
          ))}
        <LabelLine>
          <LabelLineText>0</LabelLineText>
        </LabelLine>
      </Labels>
      <Bars>
        {values.map(({ value, label }) => (
          <Bar key={`${value}:${label}`}>
            <BarValue
              style={{
                height: `${Math.min((value / maxValue) * 100, 100)}%`
              }}
            />
            <BarText>{label}</BarText>
          </Bar>
        ))}
      </Bars>
    </Container>
  );
}

LiveRdcBarChart.propTypes = {
  maxValue: PropTypes.number.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  )
};

export default LiveRdcBarChart;
